<template>
    <toggle-button
        :value="toggle ? true : false"
        :labels="labels"
        :width="200"
        :height="50"
        class="mr-2"
        :font-size="16"
        @change="publishProfile($event)"
    />
</template>

<script>
import axios from 'axios'
import { ToggleButton } from 'vue-js-toggle-button'

Vue.component('ToggleButton', ToggleButton)

export default {
    components: {
        ToggleButton
    },

    props: {
        route: {},
        routeparam: {},
        toggle: {},
        labels: {},
    },

    data() {
        return {
            isHidden: true,
            success: false,
            loaded: true,
        }
    },

    methods: {
        publishProfile(event) {
            let value = event.value ? 1 : 0;

            if (this.loaded) {
                this.loaded = false;
                this.success = false;
                axios.put(this.route,
                    { [this.routeparam]: value }
                )
                .then(response => {
                    location.reload();
                });
            }
        },
    },
}
</script>
